module.exports = __webpack_public_path__ + "static/img/frontPage21.fdc0f0bc.png";